(function () {
    var _state = {};

    function init(id) {
        if (_state[id]) return;
        var el = document.getElementById('lindenSlideshow-' + id);
        if (!el) return;
        var speed = parseInt(el.getAttribute('data-speed')) || 4000;
        _state[id] = { current: 0 };
        _state[id].timer = setInterval(function () {
            lindenSS_slide(id, 1);
        }, speed);
    }

    window.lindenSS_slide = function (id, dir) {
        var el = document.getElementById('lindenSlideshow-' + id);
        if (!el) return;
        var slides = el.querySelectorAll('.linden-slideshow__slide');
        var total = slides.length;
        if (!_state[id]) _state[id] = { current: 0 };
        _state[id].current = (_state[id].current + dir + total) % total;
        _update(id);
    };

    window.lindenSS_goto = function (id, index) {
        if (!_state[id]) _state[id] = { current: 0 };
        _state[id].current = index;
        _update(id);
    };

    function _update(id) {
        var el = document.getElementById('lindenSlideshow-' + id);
        if (!el) return;
        var track = el.querySelector('.linden-slideshow__track');
        var dots = el.querySelectorAll('.linden-ss__dot');
        var cur = _state[id].current;
        track.style.transform = 'translateX(-' + (cur * 100) + '%)';
        dots.forEach(function (d, i) {
            d.classList.toggle('active', i === cur);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('.linden-slideshow').forEach(function (el) {
            var id = el.id.replace('lindenSlideshow-', '');
            init(id);
        });
    });
})();
